import React from "react";
import Card from "components/Card/Card";
import Page from "components/Page/Page";
import UpdateProfileForm from "./components/UpdateProfileForm";

const Profile = () => {
  return (
    <Page>
      <Card title="Your Details" subTitle="Present yourself to others">
        <UpdateProfileForm />
      </Card>
    </Page>
  );
};

export default Profile;
